export const screenPrintingTiers = [
  { range: "6-11", perPiece: "$18.00", addlColor: "+$2.50/color", popular: false, min: 6, max: 11, price: 18.00, colorAdd: 2.50 },
  { range: "12-23", perPiece: "$14.00", addlColor: "+$2.00/color", popular: false, min: 12, max: 23, price: 14.00, colorAdd: 2.00 },
  { range: "24-47", perPiece: "$11.00", addlColor: "+$1.75/color", popular: false, min: 24, max: 47, price: 11.00, colorAdd: 1.75 },
  { range: "48-71", perPiece: "$8.50", addlColor: "+$1.50/color", popular: true, min: 48, max: 71, price: 8.50, colorAdd: 1.50 },
  { range: "72-143", perPiece: "$7.00", addlColor: "+$1.25/color", popular: false, min: 72, max: 143, price: 7.00, colorAdd: 1.25 },
  { range: "144-287", perPiece: "$6.00", addlColor: "+$1.00/color", popular: false, min: 144, max: 287, price: 6.00, colorAdd: 1.00 },
  { range: "288+", perPiece: "$5.00", addlColor: "+$0.75/color", popular: false, min: 288, max: 9999, price: 5.00, colorAdd: 0.75 },
];

export const dtfTiers = [
  { range: "1-11", perPiece: "$16.00", popular: false, min: 1, max: 11, price: 16.00 },
  { range: "12-23", perPiece: "$13.00", popular: false, min: 12, max: 23, price: 13.00 },
  { range: "24-47", perPiece: "$10.50", popular: true, min: 24, max: 47, price: 10.50 },
  { range: "48-71", perPiece: "$8.00", popular: false, min: 48, max: 71, price: 8.00 },
  { range: "72-143", perPiece: "$6.50", popular: false, min: 72, max: 143, price: 6.50 },
  { range: "144+", perPiece: "$5.50", popular: false, min: 144, max: 9999, price: 5.50 },
];

export const embroideryTiers = [
  { range: "12-23", perPiece: "$16.00", popular: false, min: 12, max: 23, price: 16.00 },
  { range: "24-47", perPiece: "$13.00", popular: true, min: 24, max: 47, price: 13.00 },
  { range: "48-71", perPiece: "$11.00", popular: false, min: 48, max: 71, price: 11.00 },
  { range: "72-143", perPiece: "$9.00", popular: false, min: 72, max: 143, price: 9.00 },
  { range: "144+", perPiece: "$7.50", popular: false, min: 144, max: 9999, price: 7.50 },
];

export const garmentOptions = [
  { name: "Gildan 5000 Heavy Cotton Tee", price: 2.50, category: "Budget" },
  { name: "Gildan 64000 Softstyle Tee", price: 3.00, category: "Budget" },
  { name: "Next Level 3600 Cotton Tee", price: 3.50, category: "Mid-Range" },
  { name: "Bella Canvas 3001CVC Jersey Tee", price: 4.00, category: "Mid-Range" },
  { name: "Comfort Colors 1717 Heavyweight Tee", price: 5.50, category: "Premium" },
  { name: "AS Colour 5001 Staple Tee", price: 5.00, category: "Premium" },
  { name: "Gildan 18000 Crewneck Sweatshirt", price: 7.50, category: "Sweatshirt" },
  { name: "Independent IND4000 Hoodie", price: 12.00, category: "Hoodie" },
  { name: "Core365 88181 Polo", price: 8.00, category: "Polo" },
  { name: "Richardson 112 Trucker Cap", price: 4.50, category: "Hat" },
  { name: "Customer Supplied Garment", price: 0, category: "Own" },
];

export const rushPricing = [
  { name: "5-7 Day Rush", premium: "+$2.00/pc", note: "Perfect for planned but tight deadlines" },
  { name: "3-4 Day Rush", premium: "+$4.00/pc", note: "Expedited production for urgent orders" },
  { name: "Same Day*", premium: "Call for pricing", note: "Subject to availability. Call (214) 555-0190" },
];

export const pricingNotes = [
  "Prices shown are for printing only — blank garment cost is additional",
  "Standard garment pricing: Gildan 5000 (+$2.50/pc), Next Level 3600 (+$3.50/pc), premium brands available",
  "Prices are for single-location, front or back print. Additional locations available",
  "All prices include standard screen setup fees for orders 24+",
  "Screen setup fees for <24 pieces: $20/screen/color",
  "Free local delivery on orders of 24+ pieces within DFW",
  "Prices quoted are starting points — request a quote for exact pricing on your order",
];
